import React, { Component } from "react";

export class Step1Business extends Component {
  state = {
    businessName: "",
    ownerName: "",
    mobile: "",
    whatsapp: "",
    email: "",
    city: "",
    state: "",
    address: "",
    businessCategory: "",
    errors: {},
  };

  validate = () => {
    let errors = {};

    if (!this.state.businessName.trim())
      errors.businessName = "Business Name is required.";

    if (!this.state.ownerName.trim())
      errors.ownerName = "Owner Name is required.";

    if (!this.state.mobile.trim())
      errors.mobile = "Mobile Number is required.";

    if (!this.state.whatsapp.trim())
      errors.whatsapp = "WhatsApp Number is required.";

    if (!this.state.email.trim())
      errors.email = "Email Address is required.";

    if (!this.state.city.trim())
      errors.city = "City is required.";

    if (!this.state.state.trim())
      errors.state = "State is required.";

    if (!this.state.address.trim())
      errors.address = "Address is required.";

    if (!this.state.businessCategory)
      errors.businessCategory = "Please select Business Category.";

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleNext = () => {
    if (this.validate()) {
      this.props.updateFormData({
        businessName: this.state.businessName,
        ownerName: this.state.ownerName,
        mobile: this.state.mobile,
        whatsapp: this.state.whatsapp,
        email: this.state.email,
        city: this.state.city,
        state: this.state.state,
        address: this.state.address,
        businessCategory: this.state.businessCategory,
      });

      this.props.nextStep();
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 1 : Business Information
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Business Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Business Name *</label>

                <input
                  type="text"
                  className="form-control"
                  name="businessName"
                  value={this.state.businessName}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.businessName}
                </small>
              </div>

              {/* Owner Name */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Owner Name *</label>

                <input
                  type="text"
                  className="form-control"
                  name="ownerName"
                  value={this.state.ownerName}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.ownerName}
                </small>
              </div>

              {/* Mobile */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Mobile Number *</label>

                <input
                  type="tel"
                  className="form-control"
                  name="mobile"
                  value={this.state.mobile}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.mobile}
                </small>
              </div>

              {/* WhatsApp */}
              <div className="col-md-6 mb-3">
                <label className="form-label">WhatsApp Number *</label>

                <input
                  type="tel"
                  className="form-control"
                  name="whatsapp"
                  value={this.state.whatsapp}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.whatsapp}
                </small>
              </div>

              {/* Email */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Email Address *</label>

                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.email}
                </small>
              </div>

              {/* Business Category */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Business Category *
                </label>

                <select
                  className="form-select"
                  name="businessCategory"
                  value={this.state.businessCategory}
                  onChange={this.handleChange}
                >
                  <option value="">Select Category</option>
                  <option>Restaurant</option>
                  <option>Cafe</option>
                  <option>Salon</option>
                  <option>Gym</option>
                  <option>Hospital</option>
                  <option>Clinic</option>
                  <option>School</option>
                  <option>Retail Shop</option>
                  <option>Real Estate</option>
                  <option>Startup</option>
                  <option>Corporate</option>
                  <option>Manufacturing</option>
                  <option>IT Company</option>
                  <option>Other</option>
                </select>

                <small className="text-danger">
                  {errors.businessCategory}
                </small>
              </div>

              {/* Address */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Business Address *
                </label>

                <textarea
                  className="form-control"
                  rows="4"
                  name="address"
                  value={this.state.address}
                  onChange={this.handleChange}
                ></textarea>

                <small className="text-danger">
                  {errors.address}
                </small>
              </div>

              {/* City */}
              <div className="col-md-6 mb-6">
                <label className="form-label">City *</label>

                <input
                  type="text"
                  className="form-control"
                  name="city"
                  value={this.state.city}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.city}
                </small>
              </div>

              {/* State */}
              <div className="col-md-6 mb-6">
                <label className="form-label">State *</label>

                <input
                  type="text"
                  className="form-control"
                  name="state"
                  value={this.state.state}
                  onChange={this.handleChange}
                />

                <small className="text-danger">
                  {errors.state}
                </small>
              </div>

            </div>

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Back
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default Step1Business;